var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "trims-list" },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "w-100" }, [_c("trim-card-loader")], 1)
        : _vm._l(_vm.trims, function(trim, key) {
            return _c("trim-card", {
              key: trim.id,
              attrs: {
                trim: trim,
                "base-trim": _vm.previousTrim(key),
                active: _vm.isActive(trim)
              },
              on: {
                select: function($event) {
                  return _vm.onSelected(trim)
                },
                compare: _vm.onCompare,
                "view-all-options": _vm.viewAllOptions
              }
            })
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }